import { Language } from '../../types/language'

export type HeroCopy = {
  headline: string
  headlineIntro: string
  subheadline: string
  logoAlt: string
  mainImageAlt: string
  portraitAlt: string
  coachHeading: string
  expectations: string
  intro: string[]
  fullStory: string[]
  recognizable: string
  recognizableLink: string
  aboutLink: string
  storyLink: string
  storyLinkOpen: string
  primaryCta: string
  secondaryCta: string
}

export const heroCopy: Record<Language, HeroCopy> = {
  nl: {
    headline: 'Is dit het nou?',
    headlineIntro:
      'Een vraag die veel mensen zich stellen een paar jaar na hun studie. Het werk loopt, maar er mist iets. Er zijn te veel keuzes en je weet niet welk pad echt van jou is. Ik weet hoe dat voelt, want ik zat er zelf ook.',
    subheadline:
      'Van vastzitten in maatschappelijke verwachtingen naar een leven dat je zelf kiest.',
    logoAlt: 'Mark V Coaching logo',
    mainImageAlt: 'Mark wandelt in gesprek met een cliënt en zijn hond over een pad langs de weilanden',
    portraitAlt: 'Mark Vermeulen',
    coachHeading: 'Jouw coach',
    expectations:
      '"Kies een studie met baanzekerheid." "Werk bij een groot bedrijf." "Bouw een succesvolle carrière." "Klim op de ladder." "Koop een huis."',
    intro: [
      'Jarenlang dacht ik dat succes betekende: het pad volgen dat de maatschappij voor me had uitgestippeld. Coaching leerde me dat succes niet iets is wat je bereikt, maar iets wat je zelf bepaalt door jezelf de juiste vragen te stellen.',
      'Die omslag veranderde mijn leven en inspireerde me om anderen te helpen een richting te vinden die echt van hen is.',
    ],
    fullStory: [
      'Ik ken het gevoel om alles goed te doen en toch vast te zitten. Juist daarom geef ik geen antwoorden, maar help ik je de vragen te stellen die er voor jou toe doen.',
      'In mijn gesprekken is ruimte voor twijfel, rommelige gedachten en ook voor lichte momenten. Je hoeft nog niet te weten waar je heen wilt om te beginnen. Dat zoeken we samen uit.',
    ],
    recognizable: 'Herkenbaar?',
    recognizableLink: 'Plan een kennismaking',
    aboutLink: 'Lees meer over Mark',
    storyLink: 'Lees mijn verhaal',
    storyLinkOpen: 'Lees minder',
    primaryCta: 'Boek een sessie',
    secondaryCta: 'Ontdek de retreats',
  },
  en: {
    headline: 'Is this really it?',
    headlineIntro:
      'A question many people ask themselves a few years after graduating. Work is going fine, but something is missing. There are too many choices, and you do not know which path is truly yours. I know how that feels, because I have been there myself.',
    subheadline:
      "From stuck in society's expectations to a life you choose yourself.",
    logoAlt: 'Mark V Coaching logo',
    mainImageAlt: 'Mark walking and talking with a client and his dog along a path by the meadows',
    portraitAlt: 'Mark Vermeulen',
    coachHeading: 'Your Coach',
    expectations:
      '"Choose a degree with job security." "Work for a large company." "Build a successful career." "Climb the corporate ladder." "Buy a house."',
    intro: [
      "For years, I believed that success meant following the path society had laid out for me. Coaching taught me that success isn't something you achieve; it's something you define by asking yourself the right questions.",
      'That shift changed my life and inspired me to help others create a direction that truly feels like their own.',
    ],
    fullStory: [
      'I know the feeling of doing everything right and still being stuck. That is exactly why I do not hand you answers, but help you ask the questions that matter to you.',
      'In my sessions there is room for doubt, messy thoughts, and lighter moments too. You do not need to know where you are heading to begin. We figure that out together.',
    ],
    recognizable: 'Recognizable?',
    recognizableLink: 'Book an intro call',
    aboutLink: 'Read more about Mark',
    storyLink: 'Read my story',
    storyLinkOpen: 'Read less',
    primaryCta: 'Book a Session',
    secondaryCta: 'Discover the retreats',
  },
}
